/* eslint-disable import/no-named-as-default-member */
/* eslint-disable import/no-named-as-default */
import {
  Swiper, EffectFade, Navigation, Pagination,
} from 'swiper';
import throttle from '../../../resources/scripts/utils/throttle';

const swiperContainerClass = '.hero__swiper';
let swipers = [];
let width = window.innerWidth;
const medias = document.querySelectorAll('.hero__content');
const mediaContent = document.querySelectorAll('.hero__media-content');
const brightcoveVideos = document.querySelectorAll('.video-js');
const height = [];

function changeAspectRatio(timeout = 1000) {
  return new Promise((resolve) => {
    setTimeout(() => {
      medias.forEach((media, key) => {
        mediaContent[key].style.aspectRatio = media.clientWidth / media.clientHeight;
        if (media.classList.contains('hero__media--scroll-animation')) {
          // eslint-disable-next-line no-param-reassign
          media.closest('.hero__background').style.height = `${mediaContent[key].closest('.hero__slide').clientHeight}px`;
        }
      });
      resolve();
    }, timeout);
  });
}

if (brightcoveVideos) {
  brightcoveVideos.forEach((video) => {
    // eslint-disable-next-line no-undef
    videojs.getPlayer(video).on('posterchange', (event) => {
      const img = document.createElement('img');
      img.src = event.target.querySelector('video').poster;

      img.onload = () => {
        changeAspectRatio(0).then(() => {
          if (swipers.length) {
            swipers.forEach((swiper) => {
              swiper.updateAutoHeight();
            });
          }
        });
      };
    });
  });
}

function changeBackgroundImage(swiper) {
  const images = swiper.el.closest('.hero').querySelectorAll('.hero__background');

  images.forEach((image) => {
    if (image.id === swiper.slides[swiper.activeIndex].dataset.bacgroundId) {
      // eslint-disable-next-line no-param-reassign
      image.style.opacity = '';
    } else {
      // eslint-disable-next-line no-param-reassign
      image.style.opacity = '0';
    }
  });
}
function refreshTabindex(swiper) {
  const links = swiper.el.querySelectorAll('.hero__text a');

  links.forEach((link) => {
    if (link.closest('.swiper-slide').dataset.swiperSlideIndex === String(swiper.realIndex)) {
      link.setAttribute('tabindex', '0');
    } else {
      link.setAttribute('tabindex', '-1');
    }
  });
}

function initSwiper(container) {
  // eslint-disable-next-line no-new
  const swiper = new Swiper(container, {
    loop: container.querySelectorAll('.swiper-slide').length > 1,
    slidesPerView: 1,
    grabCursor: true,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    modules: [EffectFade, Navigation, Pagination],
    navigation: {
      nextEl: container.querySelector('.hero__button-next'),
      prevEl: container.querySelector('.hero__button-prev'),
    },
    autoHeight: true,
    pagination: {
      el: '.hero__pagination',
      type: 'fraction',
      renderFraction: (currentClass, totalClass) => `<span class="${currentClass}"></span> &mdash; <span class="${totalClass}"></span>`,
    },
    on: {
      init: refreshTabindex,
      realIndexChange: refreshTabindex,
      slideChangeTransitionStart: changeBackgroundImage,
    },
  });

  if (typeof container === 'string') {
    swipers = swiper;
  } else {
    swipers.push(swiper);
  }
}

function initHero(container) {
  if (typeof container === 'string') {
    document.querySelectorAll(container).forEach((el) => {
      initSwiper(el);
    });
  } else {
    initSwiper(container);
  }
}

function restartSwiper() {
  if (window.innerWidth !== width) {
    width = window.innerWidth;

    changeAspectRatio().then(() => {
      if (swipers.length) {
        swipers.forEach((swiper) => {
          swiper.destroy();
        });
      }
      swipers = [];
      document.querySelectorAll(swiperContainerClass).forEach((el) => {
        initSwiper(el);
      });
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  changeAspectRatio().then(() => {
    if (window.acf) {
      window.acf.addAction('render_block_preview/type=azds/hero', ($block) => {
        initHero($block.find(swiperContainerClass)[0]);
      });
    } else {
      initHero(swiperContainerClass);
    }
  });
});

window.addEventListener('resize', throttle(() => {
  restartSwiper();
}, 50));

function throttleNew(f, delay) {
  let timer = 0;
  return function (...args) {
    clearTimeout(timer);
    timer = setTimeout(() => f.apply(this, args), delay);
  };
}

const ro = new ResizeObserver(throttleNew((entries) => {
  entries.forEach((entry, key) => {
    if (height && entry.contentRect.height !== height[key]) {
      height[key] = entry.contentRect.height;
      changeAspectRatio().then(() => {
        document.querySelectorAll('.hero__swiper-wrapper').forEach((el) => {
          // eslint-disable-next-line no-param-reassign
          el.style.height = '';
        });
      });
    }
  });
}, 500));

document.querySelectorAll('.hero__background').forEach((el) => {
  ro.observe(el);
});
